import { Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import { FC } from "react";

interface HtmlDialogProps {
  open: boolean;
  onClose: () => void;
  title: string;
  content: string;
}

const HtmlDialog: FC<HtmlDialogProps> = ({ open, onClose, title, content }) => {
  return (
    <Dialog
      onClose={onClose}
      open={open}
      maxWidth="md"
      fullWidth={true}
    >
      <DialogTitle
        style={{
          padding: 8,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            fontSize: 16,
          }}
        >
          {title}
          <Button
            onClick={onClose}
            size="small"
          >
            x
          </Button>
        </div>
      </DialogTitle>
      <DialogContent>
        <div
          dangerouslySetInnerHTML={{
            __html: content,
          }}
        ></div>
      </DialogContent>
    </Dialog>
  );
};

export default HtmlDialog;
